import { Button } from 'components/ui/button';
import { Icon } from 'components/ui/icon';
import React from 'react';

interface IProps {
  onBack?: () => void;
  content?: string;
}

const BackButton = ({ onBack, content }: IProps): JSX.Element => {
  const routeBack = () => {
    window.history.back();
  };

  return (
    <Button
      variant="ghost"
      data-testid="backButton"
      onClick={onBack || routeBack}
      className="inline-flex items-center m-0 mb-2 h-auto p-0 font-normal text-xs leading-4 text-gray-blue-60 hover:enabled:bg-white"
    >
      <Icon name="chevron-left" size={16} />
      {content || 'Back'}
    </Button>
  );
};

export default BackButton;
